import React from 'react';
import * as Colors from './colors';
import * as Spacing from './spacing';
import * as Typography from './typography';
import * as Mixins from './mixins';
import * as Commons from './commons';

export const Icon = ({ type="baseline", name, ...props }) => <Typography.FlowingIcon name={`${name}-${type}`} {...props} />;
export { Typography, Spacing, Colors, Mixins, Commons };
